<template>
  <ContentSection permissions="Feedback and Complaint Internal Issue" :detail="internalIssue"
    approval-title="Investigation Internal Issue (QA/QC Manager)" @on-revision="handleRevision"
    @on-approve="handleApprove" @on-close="handleClose" nextStep="Investigation Customer Issue"
    revision-from-text="QA/QC Manager">
    <template #initial-form>
      <div>
        <div
          v-permissions="'View All Feedback and Complaint Internal Issues,View Feedback and Complaint Internal Issues,Create Feedback and Complaint Internal Issue,Edit Feedback and Complaint Internal Issue'"
          v-if="!internalIssue || (internalIssue && internalIssue?.status?.value === 'pending')"
          class="white-box mm15 p30 mb-3" style="min-height: auto;">
          <div class="popup-item p-0">
            <div class="row">
              <div class="col-sm-12">
                <div class="d-flex flex-row justify-content-between align-items-center mb-4">
                  <div class="ft-16 font-bold">Investigation Internal Issue (QA/QC)</div>
                </div>
                <div class="d-flex flex-column gap-2">
                  <div v-if="internalIssue"
                    class=" btn-border-green border-dashed rounded w-100 p-3 d-flex align-items-center justify-content-between">
                    <div class="ft-14 d-flex flex-row justify-content-between align-items-center">
                      <img :src="IconCheck" alt="check" style="margin-right: 8px;" />
                      <span>Internal Issue</span>
                    </div>
                    <button class="btn btn-see ft-14"
                      @click="$router.push(`/feedback/${$route.params.id}/internal-issue/edit`)">
                      Edit
                    </button>
                  </div>
                  <router-link v-else :to="`/feedback/${$route.params.id}/internal-issue`"
                    class="btn btn-border-orange border-dashed w-100">Input Internal Issue</router-link>
                  <button @click="onSubmit" :disabled="!internalIssue" type="button"
                    class="btn btn-orange w-100">Submit</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #submitted-form="{ toggleCollapse, isCollapse, openModal, closeModal, modal }">
      <div v-if="internalIssue && !['pending'].includes(internalIssue?.status?.value)" class="white-box mm15 p30 mb-3"
        style="min-height: auto;">
        <div class="popup-item p-0">
          <div class="row">
            <div class="col-sm-12">
              <div class="d-flex flex-row justify-content-between align-items-center">
                <div class="ft-16 font-bold">Investigation Internal Issue (QA/QC)</div>
                <button @click="toggleCollapse" class="btn btn-transparent" :class="{ 'rotate': isCollapse }"><span
                    class="icon-ico-arrow-down"></span></button>
              </div>
              <div class="card-content" :class="{ 'show': isCollapse }">
                <div class="popup-item">
                  <div class="row">
                    <div class="col-sm-6 col-6">
                      <div class="grey">Preventive Action</div>
                      <span>{{ internalIssue?.preventive_action }}</span>
                    </div>
                    <div class="col-sm-6 col-6">
                      <div class="grey">Corrective Action</div>
                      <span>{{ internalIssue?.corrective_action }}</span>
                    </div>
                  </div>
                </div>
                <div class="popup-item">
                  <div class="row">
                    <div class="col-sm-6 col-6">
                      <div class="grey">Root Cause</div>
                      <span>{{ internalIssue?.root_couse }}</span>
                    </div>
                  </div>
                </div>
                <button @click="openModal('detail')" class="btn btn-see ft-14 mt-3">
                  Show detail
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Detail Modal -->
        <div class="popup-wrapper" :class="{ 'showing': modal.detail }">
          <div class="popup-card p25" style="max-width: 80vw;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="font-bold">Investigation Internal Issue (QA/QC)</div>
              <button @click="closeModal('detail')" class="btn btn-for-close"><span
                  class="icon-ico-close"></span></button>
            </div>
            <div class="inner-land" style="max-height: 80vh; overflow-y: auto; overflow-x: hidden;">
              <div class="popup-item">
                <div class="row gx-5">
                  <div class="col-6">
                    <div class="popup-item wb">
                      <div class="row">
                        <div class="col-sm-6 col-6">
                          <div class="grey">Distribute to</div>
                          <span>{{ internalIssue?.distribute_to }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="popup-item">
                      <div class="row">
                        <div class="col-sm-6 col-6">
                          <div class="grey">Date</div>
                          <span>{{ moment(internalIssue?.date, 'YYYY-MM-DD').format('DD-MM-YYYY') }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="popup-item">
                      <div class="row">
                        <div class="col-sm-6 col-6">
                          <div class="grey">Preventive Action</div>
                          <span>{{ internalIssue?.preventive_action }}</span>
                        </div>
                        <div class="col-sm-6 col-6">
                          <div class="grey">Corrective Action</div>
                          <span>{{ internalIssue?.corrective_action }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="popup-item">
                      <div class="row">
                        <div class="col-sm-6 col-6">
                          <div class="grey">Root Cause</div>
                          <span>{{ internalIssue?.root_couse }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="popup-item">
                      <div class="row">
                        <div class="col-sm-6 col-6">
                          <div class="grey">Description</div>
                          <span>{{ internalIssue?.description }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="popup-item">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="grey">Photo</div>
                          <div class="d-flex flex-row gap-2" style="flex-wrap: wrap;">
                            <img v-for="photo in internalIssue?.photos" :src="photo" :alt="photo" :key="photo"
                              style="max-width: 186px;" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="popup-item">
                      <div class="row">
                        <div class="col-sm-6 col-6">
                          <div class="grey">Prepared by</div>
                          <span>{{ internalIssue?.qc_detail?.name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="ft-18 font-bold mb15">Comments</div>

                    <form @submit.prevent="sendComment" ref="formComment" class="mb24">
                      <div class="row align-items-center mb5">
                        <div class="d-flex align-items-baseline mb5 gap-3">
                          <div style="flex: 1;">
                            <FieldTextInput name="Comment" label="" placeholder="Write your comment here..."
                              class="mb-2" v-model="comment.message" />
                          </div>
                          <div>
                            <div class='file'>
                              <label for='input-file'>
                                <span class="icon-ico-attach"></span>
                              </label>
                              <input multiple id='input-file' type='file' @change="uploadAttach" />
                            </div>
                            <input class="d-none" />
                          </div>
                        </div>
                        <small v-if="comment.attachments.length === 0" class="text-danger text-sm px-3">*format files:
                          .jpg, .png,
                          .pdf with max size 5mb</small>
                      </div>
                      <button type="submit" class="btn btn-orange w-100">Send</button>

                      <div v-if="Array.isArray(comment.attachments) && comment.attachments.length > 0">
                        <div class="attach-file" v-for="(file, index) in comment?.attachments" :key="index">
                          <a :href="previewDoc(file)" target="_blank" class="blue"><span
                              class="icon-ico-attach grey"></span> &nbsp; <span class="icon-ico-file"></span>
                            {{ file.name }}</a>
                          <button @click="deleteFile(index)" class="btn btn-close-file"><span
                              class="red icon-ico-close"></span></button>
                        </div>
                      </div>
                    </form>

                    <div v-for="(comment, index) in comments" :key="index" class="box-comment-item mb15">
                      <div class="inner-ci">
                        <div class="comment-side">
                          <div class="d-flex mb15">
                            <div class="for-pic">
                              <div class="img-comment">
                                <img :src="UserIcon" class="w-100" :alt="comment?.commented_by">
                              </div>
                            </div>
                            <div class="for-inner-comment">
                              <div class="name-commenter">{{ comment?.commented?.name }} <span
                                  class="time-comment ml5 font-normal">{{ moment(comment?.created_at).fromNow()
                                  }}</span>
                              </div>
                              <div class="comment-section">
                                {{ comment?.message }}
                              </div>
                              <div v-if="Array.isArray(comment?.attachment) && comment?.attachment.length > 0">
                                <div v-for="(attachment, index) in comment.attachment" :key="index" class="attach-file">
                                  <a :href="attachment?.filepath" target="_blank" class="blue"
                                    style="cursor: pointer;"><span class="icon-ico-attach grey"></span>
                                    &nbsp; <span class="icon-ico-file"></span> {{ attachment?.filename }}</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #cta-edit-form>
      <div>
        <button
          v-permissions="'Create Feedback and Complaint Internal Issue,Edit Feedback and Complaint Internal Issue'"
          @click="$router.push(`/feedback/${$route.params.id}/internal-issue/edit`)"
          class="btn btn-orange mm15 w-100">Edit Internal Issue</button>
      </div>
    </template>
  </ContentSection>
</template>
<script>
import IconCheck from '@/assets/icons/check.svg';
import UserIcon from '@/assets/img/user.png';
import axios from '@/axios';
import FieldTextInput from '@/components/field/TextInput.vue';
import { showErrorMessage } from '@/utils';
import { objectToFormData } from '@/utils/formdata';
import structuredClone from 'core-js/actual/structured-clone';
import moment from 'moment';
import ContentSection from '../Content';

export default {
  name: "FNCDetailInternalIssue",
  components: {
    ContentSection,
    FieldTextInput
  },
  data() {
    return {
      comment: {
        message: '',
        attachments: []
      },
      comments: [],
      totalFilesSize: 0,
      IconCheck,
      UserIcon,
      moment
    }
  },
  async created() {
    this.$store.dispatch('getDetailFeedbackComplaintInternalIssue', this.$route.params.id)
    this.comments = structuredClone(this.detail?.comments)
  },
  methods: {
    async onSubmit() {
      try {
        const { data: responseData, status } = await axios.put(`/fnc-internal-issues/${this.$route.params.id}`, {
          status: "waiting_approval"
        });
        if (status === 200 && responseData?.data) {
          this.refreshData()
        }
      } catch (error) {
        showErrorMessage(error);
      }
    },
    async handleRevision(payload) {
      try {
        this.$store.dispatch('toggleLoadingProgress', true)
        await axios.put(`/fnc-internal-issues/${this.$route.params.id}`, {
          status: 'revision',
          revision: payload.reason
        })
        this.$notify({ type: 'success', text: 'Revision sent!' })
        if (payload.callback) payload.callback()
        this.refreshData()
      } catch (error) {
        showErrorMessage(error)
      } finally {
        this.$store.dispatch('toggleLoadingProgress', false)
      }
    },
    async handleApprove(payload) {
      try {
        this.$store.dispatch('toggleLoadingProgress', true)
        await axios.put(`/fnc-internal-issues/${this.$route.params.id}`, {
          status: 'approved',
          continue: true
        })
        this.$notify({ type: 'success', text: 'Feedback Approved!' })
        if (payload.callback) payload.callback()
        this.refreshData()
      } catch (error) {
        showErrorMessage(error)
      } finally {
        this.$store.dispatch('toggleLoadingProgress', false)
      }
    },
    async handleClose(payload) {
      try {
        this.$store.dispatch('toggleLoadingProgress', true)
        await axios.put(`/fnc-internal-issues/${this.$route.params.id}`, {
          status: 'approved',
          continue: false
        })
        this.$notify({ type: 'success', text: 'Feedback Closed!' })
        if (payload.callback) payload.callback()
        this.refreshData()
      } catch (error) {
        showErrorMessage(error)
      } finally {
        this.$store.dispatch('toggleLoadingProgress', false)
      }
    },
    refreshData() {
      this.$store.dispatch('getDetailFeedbackComplaint', this.$route.params.id)
      this.$store.dispatch('getDetailFeedbackComplaintInternalIssue', this.$route.params.id)
    },

    // ========================================================================================
    // Comment method section
    // ========================================================================================
    uploadAttach(e) {
      let fileSizeLimit = 5120; // In MB
      let files = e.target.files
      let exitLoop = false
      Array.from(files).forEach(file => {
        // exit loop when totalfilessize in bigger than filesizelimit
        if (exitLoop) return

        if (file.type !== 'application/pdf' && file.type !== 'image/png' && file.type !== 'image/jpeg') {
          return alert('Format file not supported')
        }

        this.totalFilesSize += file.size

        if (this.totalFilesSize <= fileSizeLimit * 1024) {
          this.comment.attachments.push(file)
          e.target.value = ''
        } else {
          this.totalFilesSize -= file.size
          this.$notify({ type: 'error', title: 'Error', text: 'Total file size must be lower than 5mb' })
          exitLoop = true
        }
      })
    },
    previewDoc(file) {
      return URL.createObjectURL(file)
    },
    deleteFile(index) {
      let file = this.comment?.attachments.splice(index, 1)
      this.totalFilesSize -= file[0].size
    },
    async sendComment() {
      const isValid = await this.$validator.validateAll();
      if (isValid) {
        try {
          this.comments.unshift({
            commented_by: this.AppActiveUser?.nik,
            commented: {
              name: this.AppActiveUser?.name
            },
            message: this.comment?.message,
            created_at: new Date(),
            attachment: this.comment?.attachments.map(attachment => ({
              filename: attachment?.name,
              filepath: URL.createObjectURL(attachment),
              mimetype: attachment?.type
            }))
          })

          const data = objectToFormData(structuredClone(this.comment))
          await axios.post(`/fnc/${this.$route.params.id}/send-comment`, data, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
          })
          this.$validator.reset()
        } catch (error) {
          showErrorMessage(error)
        } finally {
          this.comment = {
            message: '',
            attachments: []
          }
        }
      }
    },
  },
  computed: {
    AppActiveUser() { return this.$store.state.AppActiveUser },
    detail() {
      return this.$store.state?.feedbackComplaint?.detail
    },
    internalIssue() {
      return this.$store.state?.feedbackComplaint?.internalIssue
    },
  },
}
</script>
